import React, { useEffect } from 'react'
import { EnvironmentOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, Row, Space, Typography } from 'antd'

const { Link } = Typography

const getEnvSite = () => {
  if (typeof window !== 'undefined') {
    switch (window.location.hostname) {
      case 'localhost':
        return 'https://paymentsstg.cure.com/'
      case 'staging.cure.com':
        return 'https://paymentsstg.cure.com/'
      case 'prepublish.cure.com':
        return 'https://paymentsprep.cure.com/'
      default:
        return 'https://payments.cure.com/'
    }
  }
}

const OneTimePayment = () => {
  // Redirect page to payments.cure.com
  useEffect(() => {
    window.location.href = getEnvSite()
  }, [])
  return (
    <>
      <div className="one-time-payment-screen">
        <Col
          className="margin-auto"
          lg={{ span: 8 }}
          md={{ span: 24 }}
          sm={{ span: 24 }}
          xl={{ span: 12 }}
          xs={{ span: 24 }}
        >
          <Card bordered={false} title={'One-Time Payment'}>
            <Row className="account-text">
              <a className="subtext">Make a one-time payment using your checking, savings, credit or debit card.</a>
              <a className="subtext">A convenience fee of $14.95 applies.</a>
            </Row>
            <Form>
              <Form.Item>
                <Input className="input-text" placeholder="Policy Number" prefix={<img className="policy-number" />} />
              </Form.Item>
              <Form.Item>
                <Input className="input-text" placeholder="Zip Code" prefix={<EnvironmentOutlined />} />
              </Form.Item>
              <Form.Item className="btn-control">
                <Space>
                  <Button className="button" htmlType="submit">
                    Start Payment
                  </Button>
                </Space>
              </Form.Item>
              <Row className="forgot-links">
                <Link className="forgot-text">Looking for other payment options?</Link>
                <Link>Click here</Link>
              </Row>
            </Form>
          </Card>
        </Col>
      </div>
    </>
  )
}

OneTimePayment.propTypes = {}

export default OneTimePayment
